import { AuditedEntity, Dimensions, IsoIntervalStr, Quantity } from '@elderbyte/ngx-starter'
import { PackageGroupDetails } from '../storagegroups/storage-group'
import { PackageKind } from './type/package-type'

export class Package extends AuditedEntity {
  public id: string

  public number: string

  public orderReferenceNumber: string

  public storageGroupId: string
  public packageGroupDetails: PackageGroupDetails

  public confirmationState: PackageConfirmationState

  public typeDetails: PackageTypeDetails

  public description: string

  public weight: Quantity
  public contentWeight: Quantity
  public packagingMaterialWeight: Quantity

  public dimensions: Dimensions
  public longestItemDimensions: Dimensions

  public contentDescription: string

  public location: PackageLocation
  public locationHistory: PackageLocation[]
}

export enum PackageConfirmationState {
  PREDICTED = 'PREDICTED',

  OPEN = 'OPEN',

  CONFIRMED = 'CONFIRMED',
}

export class PackageLocation {
  public storagePath: string
  public checkIn: IsoIntervalStr
  public checkout: IsoIntervalStr
}

export class PackageTypeDetails {
  public id: string
  public name: string
  public kind: PackageKind
}
